<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-agenda-layout">
            <div v-if="next" class="dw-agenda-next">
                <div class="dw-agenda-next-left">
                    <div class="dw-agenda-next-time-block">
                        <i class="bi bi-clock-fill"></i>
                        <span>{{ formatTime(next.event_at) }}</span>
                    </div>
                    <div class="dw-agenda-next-info">
                        <span class="dw-agenda-next-label">{{ $t('common.dashboard.widgetLabels.agendaNextLabel') }}</span>
                        <span class="dw-agenda-next-title">{{ next.title }}</span>
                    </div>
                </div>
                <div class="dw-agenda-next-countdown">
                    <span class="dw-agenda-next-countdown-val">{{ countdown(next.event_at) }}</span>
                    <span class="dw-agenda-next-countdown-lbl">{{ $t('common.dashboard.widgetLabels.agendaCountdownSuffix') }}</span>
                </div>
            </div>
            <div v-if="upcoming.length" class="dw-agenda-list">
                <div class="dw-agenda-item" v-for="ev in upcoming" :key="ev.id">
                    <div class="dw-agenda-dot" :style="{ background: ev.color || 'var(--bs-info)' }"></div>
                    <span class="dw-agenda-item-time">{{ formatTime(ev.event_at) }}</span>
                    <span class="dw-agenda-item-title">{{ ev.title }}</span>
                    <span class="dw-agenda-item-date">{{ formatDate(ev.event_at) }}</span>
                </div>
            </div>
            <div v-if="!next && !upcoming.length" class="dw-agenda-empty">
                <div class="dw-agenda-empty-icon"><i class="bi bi-calendar-x"></i></div>
                <div class="dw-agenda-empty-text">{{ $t('common.dashboard.widgetEmpty.agendaUpcomingTitle') }}</div>
                <div class="dw-agenda-empty-sub">{{ $t('common.dashboard.widgetEmpty.agendaUpcomingSub') }}</div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

const MONTHS = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];

export const meta = {
    id: 'agenda_upcoming',
    titleKey: 'common.dashboard.widgetTitles.agenda_upcoming',
    icon: 'bi-calendar-event',
    accent: 'var(--bs-info)',
    accentBg: 'rgba(var(--bs-info-rgb, 114, 57, 234), 0.12)',
    glassRgb: '114, 57, 234',
    defaultCol: 2,
    defaultRow: 1,
    source: { type: 'module', moduleCode: 'AGENDA', code: 'UPCOMING_LIST', defaultParams: { limit: 10 } },
};

export default {
    name: 'AgendaUpcomingWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return {
            meta,
            now: new Date(),
        };
    },
    created() {
        this._tickTimer = null;
    },
    mounted() {
        this._tickTimer = setInterval(() => { this.now = new Date(); }, 60000);
    },
    beforeUnmount() {
        if (this._tickTimer) clearInterval(this._tickTimer);
    },
    computed: {
        items() {
            return this.apiData?.items || [];
        },
        next() {
            return this.items[0] || null;
        },
        upcoming() {
            return this.items.slice(1);
        },
    },
    methods: {
        parseDate(s) {
            if (!s) return null;
            return new Date(String(s).replace(' ', 'T'));
        },
        formatTime(s) {
            const d = this.parseDate(s);
            if (!d || isNaN(d)) return '';
            return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
        },
        formatDate(s) {
            const d = this.parseDate(s);
            if (!d || isNaN(d)) return '';
            return d.getDate() + ' ' + MONTHS[d.getMonth()];
        },
        countdown(s) {
            const d = this.parseDate(s);
            if (!d || isNaN(d)) return '';
            const diff = d - this.now;
            if (diff <= 0) return this.$t('common.dashboard.widgetLabels.agendaCountdownNow');
            const totalMin = Math.floor(diff / 60000);
            const days = Math.floor(totalMin / 1440);
            const hours = Math.floor((totalMin % 1440) / 60);
            const mins = totalMin % 60;
            if (days > 0) return `${days}g ${hours}s`;
            if (hours > 0) return `${hours}s ${mins}dk`;
            return `${mins}dk`;
        },
    },
};
</script>

<style>
.dw-agenda-empty {
    flex: 1;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: 8px; text-align: center;
    padding: 8px 12px;
}
.dw-agenda-empty-icon {
    width: 56px; height: 56px;
    border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    background: rgba(var(--bs-info-rgb, 114, 57, 234), 0.10);
    color: var(--bs-info);
    margin-bottom: 4px;
}
.dw-agenda-empty-icon .bi { font-size: 26px; }
.dw-agenda-empty-text {
    font-size: 13px; font-weight: 600;
    color: var(--bs-body-color);
}
.dw-agenda-empty-sub {
    font-size: 11px; color: var(--bs-gray-500);
    line-height: 1.4; max-width: 220px;
}
</style>
